import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Header } from '@components/navigation/Header';
// import { HiOutlineCog6Tooth } from 'react-icons/hi2';
import Chatbot from '@components/chatbot/Chatbot';
import { FiSidebar } from 'react-icons/fi';
import { cn } from '@helpers/styleUtils';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import useJobRequestStore from '@stores/jobRequestStore';
import { DATA_STORE_KEYS, DataStore } from '@providers/dataStore';

const ContainerWrapper = ({ children }) => {
    const [toggleChatbot, setToggleChatbot] = useState(false);
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        const currentUserRole = DataStore.getItem(DATA_STORE_KEYS.USER_CURRENT_ROLE);
        if (isAuthenticated && ['Recruiter', 'Admin', 'Wfm'].includes(currentUserRole)) {
            const stopPolling = useJobRequestStore.getState().startPolling();
            return () => stopPolling();
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    const toggleChatbotHandler = () => {
        setToggleChatbot(prev => !prev);
    };

    return (
        <div className="container-wrapper relative mb-12">
            <Header />
            <main
                className={cn(
                    'page-wrapper h-full px-4 md:px-6 lg:px-12 py-8 flex lg:flex-row flex-col items-start gap-8 relative box-border transition-all duration-300',
                )}
            >
                <div className={cn(' lg:w-8/12 w-full box-border', toggleChatbot && 'lg:w-full')}>
                    <div className="w-full flex items-center justify-between mb-4">
                        {/* <div className="bg-white rounded-3xl flex items-center justify-center px-4 py-2 cursor-pointer hover:text-gray-500">
                            <p className="text-xs font-bold">Manage Widgets</p>
                            <HiOutlineCog6Tooth className="ml-1 text-base" />
                        </div> */}
                    </div>

                    <div className="grid grid-cols-2 gap-4">{children}</div>
                </div>
                {!toggleChatbot && (
                    <div
                        className={cn('w-full lg:w-4/12 sticky top-20 transition-all duration-300')}
                    >
                        <Chatbot toggleChatbotHandler={toggleChatbotHandler} />
                    </div>
                )}
            </main>
            {toggleChatbot && (
                <div
                    onClick={() => toggleChatbotHandler()}
                    className="group cursor-pointer fixed right-0 top-1/4 -translate-x-0 -translate-y-top-1/4 bg-primary-blue hover:bg-blue-800 text-white text-2xl rounded-l-full h-10 w-10 hover:w-32 z-[999] transition-all duration-300 flex items-center justify-center"
                >
                    <FiSidebar />
                    <p className="hidden group-hover:block text-sm font-semibold ml-2">Chatbot</p>
                </div>
            )}
        </div>
    );
};

ContainerWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default memo(ContainerWrapper);
